import { Award, ArrowRight } from 'lucide-react';
import { useCounsellingModal } from './CounsellingModal';

const FEATURES = [
  'Tuition Fee Waiver',
  'Regional Scholarships',
  'Accommodation Support',
  'Subsidized Meals',
  'Living Cost Support',
  'Government Funding',
];

const Scholarships = () => {
  const { open } = useCounsellingModal();

  return (
    <section className="scholarship-section" data-testid="scholarships-section">
      <div className="container">
        <div className="section-header">
          <div className="section-eyebrow">Scholarships</div>
          <h2 className="section-title">Study in Italy with <span className="gold-gradient">Scholarships</span></h2>
          <p className="section-subtitle">
            Italian government and regional scholarships cover tuition, accommodation, meals and a monthly stipend — making Italy the most affordable European destination.
          </p>
        </div>

        <div className="scholarship-box">
          <Award size={48} color="var(--gold)" style={{ position: 'relative', zIndex: 1 }} />
          <div className="scholarship-amount-label" style={{ marginTop: '20px' }}>Scholarships Up To</div>
          <div className="scholarship-amount">€11,000</div>
          <div className="scholarship-amount-label">Per Year — All Public Universities</div>

          <div className="scholarship-features">
            {FEATURES.map((f, i) => (
              <div key={i} className="scholarship-feature" data-testid={`scholarship-feature-${i}`}>{f}</div>
            ))}
          </div>

          <button
            className="btn-primary"
            onClick={() => open({ source: 'scholarship', message: 'I would like to check my eligibility for Italian scholarships.' })}
            data-testid="scholarship-cta"
            style={{ position: 'relative', zIndex: 1 }}
          >
            Check Eligibility <ArrowRight size={16} />
          </button>
        </div>
      </div>
    </section>
  );
};

export default Scholarships;
